import React from 'react'

import {
    Form,
    Tabs,
  Badge,
  TabBar,
  Button,ImageViewer,SideBar,List,Image,Grid,Popup,Stepper,Modal, Toast,Avatar,FloatingBubble
  ,DotLoading, SpinLoading, ProgressBar
} from 'antd-mobile-v5';
import { ClockCircleOutline } from 'antd-mobile-icons';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import 'antd/dist/antd.css';
import '../../assets/font/font.css'
import '../AsyncInfo/index.css'

import {
    CreateAsyncFuGaoInfo
} from '../../service/service';

import { environment } from '../../service/baseUrl';
import { message } from 'antd';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            dataMsg: "数据加载中",
            loadingProgress: 0,
            loadingType: 'progress', // 'simple', 'fancy', 'progress'
            isDataLoaded: false,
            loadingTips: [
                "正在努力加载数据...",
                "数据加载中，请耐心等待...",
                "即将完成，感谢您的等待...",
                "优化数据加载体验中..."
            ],
            currentTip: 0
        };
    }

    componentDidMount() {
        this.simulateDataLoading();
        this.tipInterval = setInterval(this.changeLoadingTip, 3000);

        const searchParams = new URLSearchParams(window.location.search);
        const state = searchParams.get('state');

        this.CreateAsyncFuGaoInfo(state);
    }

    CreateAsyncFuGaoInfo = (state) => {
        var that = this;
        var openid = localStorage.getItem("openid");
        var user = localStorage.getItem("user");
        if (openid == null || openid == undefined) {
            setTimeout(() => {
                this.CreateAsyncFuGaoInfo(state);
            }, 1000);
            return;
        }
        if (user == null || user == undefined) {
            setTimeout(() => {
                this.CreateAsyncFuGaoInfo(state);
            }, 1000);
            return;
        }

        CreateAsyncFuGaoInfo(state).then(res => {
            if (res.success) {
                if (res.result.item1) {
                    // that.props.navigate('/albumClass?planetId=' + res.result.item2
                    //     , { replace: true, state: { id: res.result.item2 } });

                    that.props.navigate('/home?planetId='+res.result.item2, { replace: true, state: { planetId: res.result.item2 } });

                } else {
                    Toast.show({
                        content: "内部错误！"
                    });
                }
            } else {
                Toast.show({
                    content: "内部错误！"
                });
            }
        })
    }

    componentWillUnmount() {
        clearInterval(this.tipInterval);
    }

    changeLoadingTip = () => {
        this.setState(prevState => ({
            currentTip: (prevState.currentTip + 1) % prevState.loadingTips.length
        }));
    }

    simulateDataLoading = () => {
        const progressInterval = setInterval(() => {
            this.setState(prevState => {
                const newProgress = Math.min(
                    prevState.loadingProgress + Math.floor(Math.random() * 5) + 1, 
                    100
                );
                
                if (newProgress >= 100) {
                    clearInterval(progressInterval);
                    setTimeout(() => {
                        this.setState({
                            // isDataLoaded: true,
                            dataMsg: "数据加载完成",
                            // users: this.generateMockData()
                        });
                    }, 800);
                }
                return { loadingProgress: newProgress };
            });
        }, 300);
    }

    generateMockData = () => {
        return Array.from({ length: 10 }, (_, i) => ({
            id: i + 1,
            name: `用户${i + 1}`,
            avatar: `https://randomuser.me/api/portraits/${i % 2 === 0 ? 'men' : 'women'}/${i + 1}.jpg`
        }));
    }

    changeLoadingType = (type) => {
        this.setState({
            loadingType: type,
            loadingProgress: type === 'progress' ? 0 : this.state.loadingProgress
        });
    }

    renderLoadingPage = () => {
        const { loadingType, loadingProgress, dataMsg, loadingTips, currentTip } = this.state;

        return (
            <div className="loading-page-wrapper bg-image-2">
                {/* <div className="bg-image-1"></div> */}

                {/* 方案1：渐变背景 */}
                {/* <div className="bg-gradient"></div> */}

                {/* 方案2：网格背景 */}
                {/* <div className="bg-grid"></div> */}

                {/* 方案3：抽象几何背景 */}
                {/* <div className="bg-geometric"></div> */}


                <div className="loading-container">
                    <h1 className="loading-title">{dataMsg}<DotLoading color="primary" /></h1>

                    {loadingType === 'simple' && (
                        <div className="simple-loading">
                            <SpinLoading color="primary" style={{ '--size': '48px' }} />
                            <p>{loadingTips[currentTip]}</p>
                        </div>
                    )}

                    {loadingType === 'fancy' && (
                        <div className="fancy-loading">
                            <div className="loading-animation">
                                {[...Array(3)].map((_, i) => (
                                    <div key={i} className="circle" style={{ animationDelay: `${i * 0.2}s` }} />
                                ))}
                            </div>
                            <div className="loading-message">
                                <ClockCircleOutline fontSize={24} />
                                <span>{loadingTips[currentTip]}</span>
                                <DotLoading color="primary" />
                            </div>
                        </div>
                    )}

                    {loadingType === 'progress' && (
                        <div className="progress-loading" style={{ marginTop: "5px" }}>
                            <ProgressBar
                                percent={loadingProgress}
                                style={{
                                    '--track-width': '6px',
                                    '--fill-color': '#1677ff',
                                    '--track-color': 'rgba(22, 119, 255, 0.1)'
                                }}
                            />
                            <div className="progress-info">
                                <span className="progress-percent" style={{ color: '#1677ff' }}>{loadingProgress}%</span>
                                <span className="progress-text">{loadingProgress < 50 ? '正在请求数据...' : '数据解析中...'}</span>
                            </div>
                        </div>
                    )}

                    {/* <div className="loading-tabs">
                    {['simple', 'fancy', 'progress'].map(type => (
                        <button
                            key={type}
                            className={`tab-btn ${loadingType === type ? 'active' : ''}`}
                            onClick={() => this.changeLoadingType(type)}
                        >
                            {{
                                simple: '简洁样式',
                                fancy: '动画样式',
                                progress: '进度条'
                            }[type]}
                        </button>
                    ))}
                </div> */}

                    <div className="loading-tip">
                        <span className="tip-icon">ⓘ</span>
                        网络状况良好时加载速度会更快哦~
                    </div>
                </div>

            </div>
        );
    }

    renderContent = () => {
        //Todo

    }

    render() {
        const { isDataLoaded } = this.state;

        return (
            <div className="async-index-container">
                {!isDataLoaded ? this.renderLoadingPage() : this.renderContent()}
            </div>
        );
    }
}

export default withNavigate(Index);